import { useForm, Controller } from 'react-hook-form';
import { CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { TiptapRichTextEditor } from 'components/DesignSystems/New/TiptapRichTextEditor';
import { FocusHighlightCard } from './FocusHighlightCard';
import type { SectionProps } from './types';

export function CardSpecialInstructions({
  row,
  upsertWala,
  canEditCards,
}: SectionProps) {
  const defaultValues = {
    specialInstructions: row.original.specialInstructions ?? '',
  };

  const { control, handleSubmit, reset } = useForm({ defaultValues });

  const onSubmit = handleSubmit((values) => {
    upsertWala(row, values);
    (document.activeElement as HTMLElement | null)?.blur();
  });

  return (
    <FocusHighlightCard size="sm">
      <CardHeader>
        <CardTitle>7. Special Instructions</CardTitle>
      </CardHeader>
      <CardContent className="tw:grid tw:gap-2">
        <form onSubmit={onSubmit} className="tw:grid tw:gap-4">
          <Controller
            control={control}
            name="specialInstructions"
            render={({ field }) => (
              <TiptapRichTextEditor
                value={field.value}
                onChange={field.onChange}
              />
            )}
          />
          <div className="tw:invisible tw:flex tw:gap-2 tw:group-focus-within/card:visible">
            <Button type="submit" size="sm" disabled={!canEditCards}>
              Save
            </Button>
            <Button
              type="button"
              variant="outline"
              size="sm"
              onClick={(event) => {
                reset(defaultValues);
                event.currentTarget.blur();
              }}
            >
              Cancel
            </Button>
          </div>
        </form>
      </CardContent>
    </FocusHighlightCard>
  );
}
